/**
 * Centralized transition style definitions
 *
 * These transition classes are used across components for consistent animation timing and easing.
 * All transitions use the same duration and easing function to maintain visual consistency.
 */

/**
 * Standard transition duration (300ms)
 * Used for sidebar, main content, and other layout transitions
 */
export const TRANSITION_DURATION = 'tw:duration-300';

/**
 * Standard transition easing (ease-in-out)
 * Provides smooth acceleration and deceleration
 */
export const TRANSITION_EASING = 'tw:ease-in-out';

/**
 * Standard transition for all properties
 * Use this for components that need to transition multiple properties smoothly
 */
export const TRANSITION_ALL = `tw:transition-all ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for padding-left property
 * Used for main content area when sidebar collapses/expands
 */
export const TRANSITION_PADDING_LEFT = `tw:transition-[padding-left] ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for width property
 * Used for sidebar width changes
 */
export const TRANSITION_WIDTH = `tw:transition-[width] ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for opacity
 * Used for hover states, overlays, and fade effects
 */
export const TRANSITION_OPACITY = `tw:transition-opacity ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for colors
 * Used for hover states and color changes
 */
export const TRANSITION_COLORS = `tw:transition-colors ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for transform
 * Used for slide, scale, and translate animations
 */
export const TRANSITION_TRANSFORM = `tw:transition-transform ${TRANSITION_DURATION} ${TRANSITION_EASING}`;

/**
 * Standard transition for shadow
 * Used for elevation changes
 */
export const TRANSITION_SHADOW = `tw:transition-shadow ${TRANSITION_DURATION} ${TRANSITION_EASING}`;
